import styled from 'styled-components';

import theme from 'utils/theme';
import { BreakpointValues } from 'utils/types';

export interface ResponsiveBoxProps {
  aspectRatio: number | BreakpointValues;
  rounded?: boolean;
  size?: 'small' | 'tile' | 'medium';
  skeleton?: boolean | Sproutl.ColorScheme;
}

const stylesForAspectRatio = (aspectRatio: number): any => ({
  '::before': {
    display: 'block',
    content: "''",
    width: 1,
    marginLeft: -1,
    float: 'left',
    height: 0,
    paddingTop: `${aspectRatio * 100}%`,
  },
  '::after': {
    display: 'table',
    clear: 'both',
    content: "''",
  },
});

const ResponsiveBox = styled.div<ResponsiveBoxProps>(
  ({ aspectRatio, rounded, size = 'medium', skeleton = false }) => ({
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: skeleton
      ? theme.colors[skeleton === true ? 'offWhite' : skeleton]
      : undefined,
    ...(rounded
      ? {
          borderRadius: theme.radii[size],
          // fixes rounded corners on videos for Safari
          // ref: https://gist.github.com/ayamflow/b602ab436ac9f05660d9c15190f4fd7b
          '-webkit-mask-image': '-webkit-radial-gradient(white, black)',
        }
      : {}),
    ...(typeof aspectRatio === 'number'
      ? stylesForAspectRatio(aspectRatio as number)
      : Object.entries(aspectRatio)
          .map(([breakpoint, currAspectRatio]) => [
            breakpoint,
            stylesForAspectRatio(currAspectRatio),
          ])
          .reduce((obj, [key, val]) => {
            // eslint-disable-next-line no-param-reassign
            obj[key] = val;
            return obj;
          }, {} as { [key: string]: any })),
  }),
);

export default ResponsiveBox;
